import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  emptyState: {
    padding: theme.spacing(4),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
